


























































import { computed, defineComponent, ref } from '@vue/composition-api'

import { useJsDateFormatter } from '@/composables/dates'
import store from '@/store'
import { ResumeActions } from '@/store/modules/resume/actions'
import { ResumeGetters } from '@/store/modules/resume/getters'
import { JobItemInterface } from '@/store/modules/resume/types'

export default defineComponent({
    name: 'Resume',
    setup() {
        const isResumeShowing = ref<boolean>(false)

        const resumeData = computed<Array<JobItemInterface>>(() => store.getters[ResumeGetters.All])

        store.dispatch(ResumeActions.SetResume)

        function flipResumeDisplay() {
            isResumeShowing.value = !isResumeShowing.value
        }

        return {
            flipResumeDisplay,
            isResumeShowing,
            resumeData,
            useJsDateFormatter
        }
    }
})
